import React, { useState, useEffect } from 'react';
import { CheckCircle, Clock, AlertCircle, Wrench } from 'lucide-react';
import TaskList from '../TaskList';

export default function TaskManager() {
  const [filter, setFilter] = useState<string>('all');

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center space-x-3">
          <h2 className="text-lg font-medium text-gray-900">All Tasks</h2>
          <div className="flex items-center space-x-1 text-sm text-gray-500">
            <Wrench className="w-4 h-4 text-amber-500" />
            <span>Company-wide task management</span>
          </div>
        </div>
        <div className="flex space-x-2">
          <button 
            onClick={() => setFilter('all')}
            className={`px-3 py-1 text-sm rounded-lg ${
              filter === 'all' 
                ? 'bg-blue-100 text-blue-700' 
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            All
          </button>
          <button 
            onClick={() => setFilter('pending')}
            className={`px-3 py-1 text-sm rounded-lg ${
              filter === 'pending' 
                ? 'bg-yellow-100 text-yellow-700' 
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            Pending
          </button>
          <button 
            onClick={() => setFilter('completed')}
            className={`px-3 py-1 text-sm rounded-lg ${
              filter === 'completed' 
                ? 'bg-green-100 text-green-700' 
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            Completed
          </button>
        </div>
      </div>
      
      <TaskList department="workshop" />
    </div>
  );
}